import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import CampaignTypeModalPage from '../../../containers/masters/CampaignType/CampaignTypeModalPage'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class CampaignTypeMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchCode: null,
        searchGroupId: null
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchCampaignTypeList()
    this.props.actions.fetchCampaignGroup(null)
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchCampaignTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchCampaignTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchCode) {
    if (this.state.filter.searchName !== searchCode) {
      this.setState({ filter: { ...this.state.filter, searchCode } })
    }
  }

  handleGroupChange (searchGroupId) {
    if (this.state.filter.searchGroupId !== searchGroupId) {
      this.setState({ filter: { ...this.state.filter, searchGroupId } })
    }
  }

  searchCampaign () {
    this.props.actions.fetchCampaignTypeList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchCode: null,
        searchGroupId: null
      }
    }, () => { this.searchCampaign() })
  }

  render () {
    const {
      t, campaignTypeList, pagesCount, campaignTypeCount, filter,
      combos: { campaignGroup },
      filter: { page },
      actions: { openCampaignTypeModal, fetchCampaignTypeList, recoverCampaignType, deleteCampaignType }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'campaignTypeMasterPage' })
    const tKey = 'MASTERS.CAMPAIGN_TYPE_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchCode || this.state.filter.searchGroupId)
    return (

      <div id="campaingTypeMaster" className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openCampaignTypeModal()}>
              <i className='iDocIcon-add-plus'></i>{t(`${tKey}ADD`)}
            </Button>

          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.code"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                component={InputSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="filters.campaignGroupId"
                controlLabel={t(`${tKey}GROUPTYPE`)}
                placeholder={t(`${tKey}GROUPTYPE`)}
                valueKey="id"
                labelKey="value"
                options={campaignGroup}
                onInputChange={(value) => this.handleGroupChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchCampaign()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(campaignTypeList.length !== 0) &&
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('code') }}>
                      {t(`${tKey}CODE`)}
                      <i className={this.getSortIcon('code')} />
                    </th>
                    <th onClick={() => { this.changeOrder('description') }}>
                      {t(`${tKey}DETAILS`)}
                      <i className={this.getSortIcon('description')} />
                    </th>
                    <th onClick={() => { this.changeOrder('groupCode') }}>
                      {t(`${tKey}GROUPTYPE`)}
                      <i className={this.getSortIcon('groupCode')} />
                    </th>
                    <th onClick={() => { this.changeOrder('classCode') }}>
                      {t(`${tKey}CLASSTYPE`)}
                      <i className={this.getSortIcon('classCode')} />
                    </th>
                    <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {campaignTypeList && campaignTypeList.map((campaignType, idx) => {
                    return (
                      <tr key={idx} className={campaignType.isDeleted ? 'is-deleted' : ''}>
                        <td>{campaignType.typeCode}</td>
                        <td>{campaignType.campaignTypeLanguage && campaignType.campaignTypeLanguage.length > 0 ? campaignType.campaignTypeLanguage.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected)?.description : ''}</td>
                        <td>{campaignType.campaignGroupCode}</td>
                        <td>{campaignType.campaignClassCode}</td>
                        <td className='actions'>
                          {!campaignType.isDeleted ? (
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => openCampaignTypeModal(campaignType)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                <a className='_Btn cancel stk o-icn ' onClick={() => deleteCampaignType(campaignType.campaignTypeId)}>
                                  <i className="iDocIcon-delete-forever" />
                                </a>
                              </OverlayTrigger>
                            </div>
                          ) : (
                            <div>
                              <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                <a className='_Btn accent stk o-icn ' onClick={() => recoverCampaignType(campaignType.campaignTypeId)}>
                                  <i className='iDocIcon-undo-back' />
                                </a>
                              </OverlayTrigger>
                            </div>
                          )}
                        </td>
                      </tr>)
                  })}
                </tbody>
              </Table>
              }
              {(campaignTypeList === null || campaignTypeList === undefined || campaignTypeList.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={campaignTypeCount}
                    onSelectAction={(value) => fetchCampaignTypeList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <CampaignTypeModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listCampaignType'
})(CampaignTypeMaster)
